import { CollectionModel } from '@ikegps/core-shared';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Report } from './reportTypes/Report';
import { ReportBase } from './reportTypes/ReportBase';
import { ReportCompositePhoto } from './reportTypes/ReportCompositePhoto';
import { ReportCompositePhotoOnly } from './reportTypes/ReportCompositePhotoOnly';
import { ReportPhoto } from './reportTypes/ReportPhoto';
import { ReportShort } from './reportTypes/ReportShort';

pdfMake.vfs = pdfFonts.vfs;

export enum ReportTypeEnum {
	ReportType = 'Report',
	ReportShortType = 'ReportShort',
	ReportCompositePhotoType = 'ReportCompositePhoto',
	ReportCompositePhotoOnlyType = 'ReportCompositePhotoOnly',
	ReportPhotoType = 'ReportPhoto',
}

export class PDFReportMaker {
	static makeReport(type: ReportTypeEnum, poles: CollectionModel[]): pdfMake.TCreatedPdf {
		let reportInstance: ReportBase;
		switch (type) {
			case ReportTypeEnum.ReportType:
				reportInstance = new Report(poles);
				break;
			case ReportTypeEnum.ReportShortType:
				reportInstance = new ReportShort(poles);
				break;
			case ReportTypeEnum.ReportCompositePhotoType:
				reportInstance = new ReportCompositePhoto(poles);
				break;
			case ReportTypeEnum.ReportCompositePhotoOnlyType:
				reportInstance = new ReportCompositePhotoOnly(poles);
				break;
			case ReportTypeEnum.ReportPhotoType:
				reportInstance = new ReportPhoto(poles);
				break;
			default:
				reportInstance = new Report(poles);
		}

		return pdfMake.createPdf(reportInstance.export());
	}
}
